export default {
  en: {
    supplier: {
      slide1Title: 'Build trust with clients. Fast.',
      slide1Li1: 'Speed up security reviews and close deals faster',
      slide1Li2: 'Know exactly where you are in the review process',
      slide1Li3: 'Never complete a questionnaire from scratch again',
      slide2Title: 'Save time on future assessments',
      slide2Body1: 'No more duplicate spreadsheets or repetitive work.',
      slide2Body2:
        'Build a single risk profile, share with any client, and complete assessments up to 6 weeks faster.',
      slide3Title: 'Keep up momentum and know exactly where you are in the process.',
      slide3Body1:
        'No chasing, no guesswork, just everything you need for a successful security review, all in one place.',
      slide3Body2: "And once you're finished, you can share your profile with other clients.",
      slide3CTA: 'Get started',
    },
  },
};
